export function sectionLogger(scope, debug = true) {
  function isEnabled() {
    if (typeof window === "undefined") return false;
    return window.__ZIGGY_DEBUG__ === true && debug === true;
  }

  return {
    info(message, payload) {
      if (!isEnabled()) return;
      console.info(`[${scope}] ${message}`, payload ?? "");
    },
    warn(message, payload) {
      if (!isEnabled()) return;
      console.warn(`[${scope}] ${message}`, payload ?? "");
    },
    error(message, payload) {
      if (!isEnabled()) return;
      console.error(`[${scope}] ${message}`, payload ?? "");
    },
  };
}
